// @flow
import React from 'react';
import classNames from 'classnames';
// import {connect} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
// import SwipeableViews from 'react-swipeable-views';
import styles from './Widget.styles';

class Widget extends React.Component<Props> {
    constructor(props) {
      super(props);

      this.state = {
        tabIndex: 0,
      };

      // Define a padding
      this.borderPaddingValue = 2; // set a default padding
      if (this.props.padding === false || this.props.padding === 0) {
        this.borderPaddingValue = 0;
      }
      //
    }

    handleChange = (event, tabIndex) => {
      this.setState({ tabIndex });
    };

    handleChangeIndex = tabIndex => {
      this.setState({ tabIndex });
    };

    componentDidUpdate() {
      if (this.swipeableActions) {
        this.swipeableActions.updateHeight();
      }
    }

    render() {
      const {classes} = this.props;
      const className = this.props.className || {};
      const hasBorderPadding = this.borderPaddingValue === 0 ? '' : classes.containerPadding;
      const gray = this.props.gray ? classes.containerGray : '';
      return (
        <aside className={classNames(classes.wrapper, (className.wrapper || className))}>
          <Paper
            elevation={1}
            className={classNames(classes.container, className.container, hasBorderPadding, gray)}
          >
            {this.props.title && 
              <div className={className.title || classes.title}>
                {this.props.title}
              </div>
            }
              {this.props.tabs && 
                <div className={classes.tabs}>
                  <Tabs
                    value={this.state.tabIndex}
                    onChange={this.handleChange}
                    indicatorColor="primary"
                    variant="fullWidth"
                    classes={{
                      root: classes.tabsRoot,
                      indicator: classes.tabsIndicator
                    }}
                  >
                    {this.props.tabs.map((item, index) => {
                      return(
                        <Tab
                          key={index}
                          label={item}
                          classes={{
                            root: classes.tabRoot,
                            selected: classes.tabSelected,
                            wrapper: classes.tabWrapper,
                            labelContainer: classes.tabsLabelContainer
                          }}
                        />
                      );
                    })}
                  </Tabs>
                  {this.props.children && this.props.children[this.state.tabIndex]}
                </div>
              }

            {!this.props.tabs && this.props.children}
          </Paper>
        </aside>
      );
    }
}

// const mapStateToProps = state => ({
//   user: state.user
// });

const Component = withStyles(styles)(Widget);
export {Component as Widget};
export default Component;